import { render, staticRenderFns } from "./TebligatAdresTuruPicker.vue?vue&type=template&id=dc84e9b2"
import script from "./TebligatAdresTuruPicker.vue?vue&type=script&lang=ts"
export * from "./TebligatAdresTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports